
(function () {
    'use strict';

    angular
        .module('etrrbApp')
        .factory('ETrrbService', ETrrbService);

    ETrrbService.$inject = ['$resource', 'authExpiredInterceptor', 'GLOBAL_URL'];

    function ETrrbService ($resource, authExpiredInterceptor, GLOBAL_URL) {
    	return $resource(GLOBAL_URL + 'api/ga/etrrb/:uri',{uri: '@uri'}, {
  		  'postList':   {method:'POST', isArray: true},
  		  'post':   {method:'POST'},
  		  'save': {
  			method: 'POST',
  				transformRequest: formDataObject,
  				headers: { 'Content-Type' : undefined, enctype: 'multipart/form-data'}
  			},
  			'returnValue': {
                method: 'GET',
                transformResponse: [function (data) {
                    return  { response: data };
                }],
                transformResponseError: function(error){
                	if(error.status === 0){
                		alert('There is a problem connecting to the server. Is the server probably down?!');
                	}
                	 return $q.reject(error);
                }
            },
            'updateAgentSmsRemind': {
                method: 'POST',
                transformResponse: [function (data) {
                    return  { response: data };
                }],
                transformResponseError: function(error){
                	if(error.status === 0){
                		alert('There is a problem connecting to the server. Is the server probably down?!');
                	}
                	 return $q.reject(error);
                }
            },
      });
    }
	function formDataObject (data) {
        var fd = new FormData();
        angular.forEach(data, function(value, key) {
            fd.append(key, value);
        });
        return fd;
    }
})();

